module.exports = __webpack_public_path__ + "img/medal-10-0.1fd62c27.png";